export default {
  calendarHoliday: 'Calendar holiday',

  carCategory: 'Car category',
  carType: 'Car type',
  carBrand: 'Car brand',
  carLoad: 'Car load',

  clubReferrerType: 'Club referrer type',

  cmsThemeCategory: 'cms theme category',
  cmsTheme: 'cms theme',

  blogPostCategory: 'Blog post category',
  blogPost: 'Blog post',
  blogComment: 'Blog comment',
  blogTag: 'Blog tag',

  contractCategory: 'Contract category',

  courierEquipment: 'Courier equioment',
  courierExpertise: 'Courier Experties',

  crmFaqCategory: 'crm FAQ category',
  crmCategory: 'crm category',
  crmDepartment: 'crm department',
  crmMedia: 'crm media',
  crmSubCategory: 'crm sub category',
  crmSubject: 'crm subject',
  crmContactSubject: 'crm contact subject',

  featureCapacity: 'Feature capacity',
  featureColor: 'Feature color',
  featureSize: 'Feature size',
  featureVolume: 'Feature volume',

  feedbackRateCriterion: 'Feedback rate criterion',

  financialBankAccount: 'Financial bank account',
  financialBank: 'Financial bank',
  financialPolicy: 'Financial policy',

  geoCity: 'geo city',
  geoCountry: 'geo country',
  geoCounty: 'geo county',
  geoDistrict: 'geo district',
  geoProvince: 'geo provice',
  geoTrafficPlan: 'geo traffic plan',
  organization: 'Organization',

  poi: 'poi',
  poiCategory: 'poi category',

  propertyEmployee: 'Property employee',
  propertyItemGroup: 'Property item group',
  propertyItemCategory: 'Property item category',
  propertyItemType: 'Property item type',
  propertyLoad: 'Property load',
  propertyPackageType: 'Property package type',
  propertyPackage: 'Property package',
  propertySoil: 'Property soil',

  questionnaireQuestionCategory: 'Questionnaire question category',

  reason: 'Reason',

  unitCurrency: 'Unit currency',
  unitMeasurement: 'Unit measurement',

  userGroup: 'User group',
  userLevel: 'User level',
  userEducationLevel: 'User education level',
  userLicenseType: 'User liecense type',

  tariffAuction: 'Tariff auction',
  tariffMaterial: 'Tariff material',
  tariffFurniture: 'Tariff furniture',
  tariffFurnitureCar: 'Tariff furniture car',
  tariffFurnitureEmployee: 'Tariff furniture employee',
  tariffFurnitureItem: 'Tariff furniture item',
  tariffFurnitureTrafficPlan: 'Tariff futniture traffic plan',
  tariffTrash: 'Tariff  trash',
  tariffTrashCar: 'Tariff trash car',
  login: 'Login',

  securityPermission: 'Security permission',
  securityRole: 'Security role',
  securityLimit: 'Security limit',
  securityLicencePermission: 'Security licence permission',
  securityLicenceLimit: 'Security licence limit',

  courier: 'Courier',
  user: 'User',
  address: 'Address',
  vehicle: 'Vehicle',
  driver: 'Driver',

  order: 'Order',
  orderTemplate: 'Order template',
  orderDraft: 'Order draft',

  timeSheetTrafficPlan: 'Time sheet traffic plan',
  timeSheetTrafficPlanTemplate: 'Time sheet',
  timeSheetCourier: 'Time sheet courier',
  timeSheetCourierTemplate: 'Time sheet courier template',

  gatewaySms: 'Gateway sms',
  gatewayEmail: 'Gateway email',
  gatewayNotification: 'Gateway notification',
  gatewayPayment: 'Gateway payment',
  gatewayOrder: 'Gateway order',
  gatewayPostage: 'Gateway postage',
  gatewayDelivery: 'Gateway delivery',
  gatewayPickup: 'Gateway pickup',

  bonusCouponType: 'Bounus coupon type',
  bonusGiftCardType: 'Bounus gift card type',
  bonusCoupon: 'Bounus coupon',
  bonusGiftCard: 'Bounus gift card',
  bonusCampaign: 'Bounus campain',
  bonusPromotion: 'Bounus promotion',

  sitePostCategory: 'Site post category',
  siteThemeCategory: 'Site theme category',
  siteFaqCategory: 'Site FAQ category',
  sitePost: 'Site post',
  siteTheme: 'Site theme',

  supportedOrder: 'Supported order',
  supportedCar: 'Supported car',
  supportedEmployee: 'Supported employee',
  supportedItem: 'Supported item'
}
